/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { DatePicker, message, Spin } from 'antd';
import styled from 'styled-components';
import withModal from '../../../core/components/withModals';
import FormModalStyled from '../../../core/components/modals/FormModalStyled';
import StatusCode from '../../../services/statusCode';
import { FilterSelectInputChangeAtcu } from '../../Page.styled';
import AButton from '../../../core/components/buttons/AButton';
import { useAuthStateValue } from '../../../context/AuthContext';
import { changeScheduledAtcu } from '../../../services/user.service';
import { UserSpecialRoleEnum } from '../enums/userSpecialRoleEnum';

const ChangeAtcuModal = (props) => {
  const { modalData, modalProps, closeDialog, dataSource, setDataSource, onSave } = props;

  const { loggedUser } = useAuthStateValue();
  const [loading, setLoading] = useState(false);
  const [selectedAtcu, setSelectedAtcu] = useState();
  const [selectedRole, setSelectedRole] = useState();
  const [error, setError] = useState(null);
  const [dateFrom, setDateFrom] = useState(null);

  const { t } = useTranslation();
  const id = modalData?.id;

  const onOk = async () => {
    if (!dateFrom) {
      setError('Nije naveden datum');
    } else {
      try {
        setLoading(true);
        let res;
        if (selectedAtcu !== modalData?.scheduledAtcuIdentificator) {
          res = await changeScheduledAtcu(id, selectedAtcu, selectedRole, dateFrom);
        } else {
          res = await changeScheduledAtcu(id, selectedAtcu, selectedRole, dateFrom);
        }
        if (res.status === StatusCode.OK) {
          message.success(t('users.changeAtcuSuccess'));
          props.onSave();
        }
        props.closeDialog();
      } catch (err) {
        setError(err);
        if (err.response.status === StatusCode.CONFLICT) {
          message.error(t('users.changeAtcuConflict'));
        } else {
          message.error(t('users.changeAtcuError'));
        }
        props.closeDialog();
      } finally {
        props.closeDialog();
        setLoading(false);
        onSave();
      }
    }
  }

  const arrayForSelectAtcu = [];
  loggedUser?.locationsData?.forEach((element) => {
    arrayForSelectAtcu?.push({
      title: element.identificator,
      key: element.id,
      label: element.identificator,
      value: element.identificator,
      disabled: (selectedRole === 'SATCO' && element?.identificator === 'ATCU1') || (selectedRole === 'SHIFT_MANAGER' && element?.identificator === 'ATCU2')
    })
  })

  const mapRoleSelectOptions = () => {
    const options = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const [key] of Object.entries(UserSpecialRoleEnum)) {
      options.push({
        key,
        disabled: (selectedAtcu === 'ATCU1' && key === 'SATCO') || (selectedAtcu === 'ATCU2' && key === 'SHIFT_MANAGER') || (modalData?.specialRole === 'STUDENT' && (key !== 'BASIC' && key !== 'STUDENT')) || (modalData?.specialRole !== 'STUDENT' && key === 'STUDENT'),
        label: t('users.' + key),
        value: key
      });
    }
    return options;
  };

  useEffect(() => {
    if (modalData) {
      setSelectedAtcu(modalData?.scheduledAtcuIdentificator);
      setSelectedRole(modalData?.specialRole);
    }
  }, [modalData]);

  const changeRoleHandler = (value) => {
    setSelectedRole(value);
  };

  const dateChangeHandler = (value) => {
    if (error) setError(null);
    setDateFrom(value);
  };

  return (
    <FormModalStyled
      width={620}
      footer={[]}
      afterClose={() => {
        setError(null);
      }}
      centered
      maskClosable={false}
      {...modalProps}
      title={t('users.changeAtcuTitle')}
    >
      <Container>
        <Wrapper>
          <Title>{t('users.changeAtcuTitle')}</Title>
          <FilterSelectInputChangeAtcu disabled={loading} options={arrayForSelectAtcu} onChange={(value) => setSelectedAtcu(value)} defaultValue={modalData?.scheduledAtcuIdentificator === null ? 'Nema' : modalData?.scheduledAtcuIdentificator} placeholder={t('users.changeAtcuPlaceholder')} />
        </Wrapper>
        <Wrapper>
          <Title>{t('users.changeRoleTitle')}</Title>
          <FilterSelectInputChangeAtcu disabled={loading} options={mapRoleSelectOptions()} onChange={changeRoleHandler} defaultValue={modalData?.specialRole} placeholder={t('users.changeRolePlaceholder')} />
        </Wrapper>
        <Wrapper>
          <Title>{t('users.dateFrom')}</Title>
          <DatePicker disabled={(selectedAtcu === modalData?.scheduledAtcuIdentificator && selectedRole === modalData?.specialRole) || loading} onChange={dateChangeHandler} />
        </Wrapper>
        <ErrorMessage>{error ? error : ''}</ErrorMessage>
      </Container>
      <ModalFooter>
        {loading && <Spin />}
        <ModalButton disabled={loading} onClick={closeDialog}>{t('buttons.cancel')}</ModalButton>
        <ModalButton disabled={loading} onClick={onOk}>{t('buttons.confirm')}</ModalButton>
      </ModalFooter>
    </FormModalStyled>
  );
};

ChangeAtcuModal.propTypes = {
  modalData: PropTypes.any,
  modalProps: PropTypes.any,
  closeDialog: PropTypes.func,
  dataSource: PropTypes.array,
  setDataSource: PropTypes.func,
};

const ModalButton = styled(AButton)`
  border-radius: 5px !important;
  box-sizing: border-box;
  &:hover {
    border: none !important;
  }
  &:disabled {
    background-color: #858585 !important;
    &:hover {
      background-color: #858585 !important;
      border: none !important;
    }
  }
`;

const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 200px;
`;

const ErrorMessage = styled.div`
  color: red;
  height: 30px;
  padding-left: 260px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 15px 10px;
  align-items: center;

`;

const Title = styled.div`
  font-size: 16px;
  padding-right: 20px;
  min-width: 250px;
  `;

const ModalFooter = styled.div`
  border-top: 1px solid #eaeaea;
  width: 100%;
  display:flex;
  justify-content: right;
  padding: 10px 15px 0px 0px;
  gap: 15px;
`;

export default withModal()(ChangeAtcuModal);
